import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { InputField } from 'Common/SemanticWrapper';
import { CreateEditPhysicalEnum } from 'Common/FieldEnum';

import { PhysicalItemsInfo as PhysicalItemsInfoContainer } from '../../containers/createEditPhysical/PhysicalItemsInfo';

const PreviewPhysicalComponent = props => {
  const {
    physicalItemsInfo,
    onResetPageOnDataChange,
    resetPageOnDataChange,
  } = props;
  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column width={3}>
            <Field
              name={CreateEditPhysicalEnum.Comments}
              component={InputField}
              type="text"
              maxLength={50}
              label={'Comments'}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4}>
            <label className={'text-orange'}>Physical Items</label>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <hr />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Field
              component={PhysicalItemsInfoContainer}
              name={CreateEditPhysicalEnum.PhysicalItemsInfo}
              {...{
                dataSource: physicalItemsInfo,
                isPreviewPage: true,
                onResetPageOnDataChange: onResetPageOnDataChange,
                resetPageOnDataChange: resetPageOnDataChange,
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

PreviewPhysicalComponent.propTypes = {
  physicalItemsInfo: PropTypes.array,
  onResetPageOnDataChange: PropTypes.func,
  resetPageOnDataChange: PropTypes.bool,
};

PreviewPhysicalComponent.defaultProps = {
  physicalItemsInfo: [],
  onResetPageOnDataChange: () => {},
  resetPageOnDataChange: true,
};
export default PreviewPhysicalComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/components/createEditPhysical/PreviewPhysical.js